import { AjaxForm } from "@neonjungle/birdseed/forms/ajax";

class CMSignupAjaxForm extends AjaxForm {
	toggleSubmitButtonState() {
		super.toggleSubmitButtonState();
		if (this.submitButton) {
			this.submitButton.classList.toggle("is-loading", this.submitButton.disabled);
		}
	}
}

export default function emailSubscribeForms() {
	const $subForms = document.querySelectorAll("[data-cm-signup-form]");
	$subForms.forEach($form => {
		let message = $form.querySelector("[data-cm-signup-form-message]");
		new CMSignupAjaxForm($form, message);
	});
}
